import { defaultValidatedTypes as a } from "./utils/validateType.js";
function b(e) {
  var n, i, s = "";
  if (typeof e == "string" || typeof e == "number")
    s += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var c = e.length;
      for (n = 0; n < c; n++)
        e[n] && (i = b(e[n])) && (s && (s += " "), s += i);
    } else
      for (i in e)
        e[i] && (s && (s += " "), s += i);
  return s;
}
function h() {
  for (var e, n, i = 0, s = "", c = arguments.length; i < c; i++)
    (e = arguments[i]) && (n = b(e)) && (s && (s += " "), s += n);
  return s;
}
const k = typeof window < "u", g = (e, n, i, s) => {
  const c = a.isCssUnit(e) ? n === "mobile" && e.mobile ? e.mobile : e.desktop : e;
  if (!c)
    return i ? String(i) : "";
  const f = String(c);
  if (f != null && f.match(/^[0-9.]+$/)) {
    const o = parseFloat(f), p = (s == null ? void 0 : s.desktopSize) ?? 1440, r = (s == null ? void 0 : s.mobileSize) ?? 375, d = o / (n === "desktop" ? p : r) * 100;
    return `${Number(d.toFixed((s == null ? void 0 : s.precision) ?? 6))}vw`;
  }
  return c;
}, C = (e) => !!(e != null && e.match(/^#([A-F0-9]{3,4}|[A-F0-9]{6}|[A-F0-9]{8})$/i)), $ = (...e) => h("flight-deck", ...e), R = (...e) => h(...e), w = (e, n) => $(e, n && n[e]), S = (e, n) => {
  const i = e.split(/(?=[A-Z])/).join("-").toLowerCase();
  return typeof n < "u" ? `var(--${i}, ${n})` : `var(--${i})`;
}, x = (e) => typeof e == "string" ? e.charAt(0).toUpperCase() + e.slice(1) : e, T = (e, n) => {
  const i = e.replace(/([A-Z])/g, n ?? " $1").trim();
  return x(i);
}, L = (e) => {
  if (!e)
    return !1;
  const n = e.startsWith("#") ? e.substring(1, 7) : e, i = parseInt(n.substring(0, 2), 16), s = parseInt(n.substring(2, 4), 16), c = parseInt(n.substring(4, 6), 16);
  return i * 0.299 + s * 0.587 + c * 0.114 < 186;
}, O = (e, n = 150) => {
  if (!e || !k)
    return;
  const i = e.getBoundingClientRect();
  window.scroll({
    top: i.top + window.scrollY - n,
    left: 0,
    behavior: "smooth"
  });
}, N = (e, n, i) => {
  e.key === n && i();
}, B = (e, n) => {
  if (typeof process > "u")
    return !1;
  const i = n || process.env.GATSBY_NODE_ENV;
  return Array.isArray(e) ? e.includes(i) : i === e;
};
function v(e, n) {
  let i;
  return (...s) => {
    k && (window.clearTimeout(i), i = window.setTimeout(() => {
      e(...s);
    }, n));
  };
}
function I(e, n = 250) {
  let i = !1;
  return (...s) => {
    i || (e(...s), i = !0, setTimeout(() => {
      i = !1;
    }, n));
  };
}
function P(e, n) {
  const i = (e == null ? void 0 : e.blocks) || (e == null ? void 0 : e._rawBlocks) || e, s = { ignoreNonText: !0, limit: 200 };
  if (!i || !Array.isArray(i))
    return "";
  const c = Object.assign({}, s, n);
  return i.map((f) => !c.ignoreNonText && (f._type !== "block" || !f.children) ? `[${f._type} block]` : f.children.filter((o) => (o == null ? void 0 : o._type) === "span").map((o) => o.text).filter(Boolean).join("")).join(`

`);
}
function E(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "object" && n !== null && !Array.isArray(n));
}
function W(e, n) {
  return Object.keys(e).every((i) => e[i] === n[i]);
}
function F(e) {
  var n;
  return e ? ((n = Object.keys(e)) == null ? void 0 : n.length) === 0 : !0;
}
function V(e, n) {
  return e.length === n.length && e.every((i, s) => i === n[s]);
}
function _(e, n) {
  return e.reduce((s, c, f) => {
    const o = Math.floor(f / n);
    return s[o] || (s[o] = []), s[o].push(c), s;
  }, []);
}
const H = (e, n) => {
  const i = { desktop: {}, mobile: {} }, s = e ? JSON.parse(e) : void 0, c = (r) => r.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), f = (r, t) => {
    if (!r)
      return "";
    const d = r == null ? void 0 : r.split(" ").filter(Boolean);
    return Number(d == null ? void 0 : d.length) === 3 ? [g(d[0], t), ...d.slice(1)].join(" ") : "";
  }, o = (r, t) => {
    let d = {};
    return r != null && r.maxWidth && (d.maxWidth = g(r.maxWidth, t)), r != null && r.maxHeight && (d.height = g(r.maxHeight, t)), r != null && r.backgroundColor && (d.backgroundColor = r.backgroundColor), r != null && r.textColor && (d.color = r.textColor), Object.values((r == null ? void 0 : r.borderRadius) ?? {}).length && (r != null && r.borderRadius.all ? d.borderRadius = g(r.borderRadius.all, t) : d = {
      ...d,
      borderTopLeftRadius: g(r == null ? void 0 : r.borderRadius.topLeft, t),
      borderTopRightRadius: g(r == null ? void 0 : r.borderRadius.topRight, t),
      borderBottomLeftRadius: g(r == null ? void 0 : r.borderRadius.bottomLeft, t),
      borderBottomRightRadius: g(r == null ? void 0 : r.borderRadius.bottomRight, t)
    }), Object.values((r == null ? void 0 : r.padding) ?? {}).length && (r != null && r.padding.all ? d.padding = g(r.padding.all, t) : d = {
      ...d,
      paddingLeft: g(r == null ? void 0 : r.padding.left, t),
      paddingTop: g(r == null ? void 0 : r.padding.top, t),
      paddingRight: g(r == null ? void 0 : r.padding.right, t),
      paddingBottom: g(r == null ? void 0 : r.padding.bottom, t)
    }), Object.values((r == null ? void 0 : r.border) ?? {}).length && (r != null && r.border.all ? d.border = f(r.border.all, t) : d = {
      ...d,
      borderLeft: f(r == null ? void 0 : r.border.left, t),
      borderTop: f(r == null ? void 0 : r.border.top, t),
      borderRight: f(r == null ? void 0 : r.border.right, t),
      borderBottom: f(r == null ? void 0 : r.border.bottom, t)
    }), d;
  };
  if (i.desktop = o(s == null ? void 0 : s.desktop, "desktop"), i.mobile = o(s == null ? void 0 : s.mobile, "mobile"), n === "inlineStyle")
    return i;
  const p = { desktop: [], mobile: [] };
  return Object.keys(i.desktop).forEach((r) => {
    const t = i.desktop[r];
    t && p.desktop.push(`${c(r)}: ${t};`);
  }), Object.keys(i.mobile).forEach((r) => {
    const t = i.mobile[r];
    t && p.mobile.push(`${c(r)}: ${t};`);
  }), {
    desktop: p.desktop.join(`
`),
    mobile: p.mobile.join(`
`)
  };
}, j = ({
  slug: e,
  prefix: n,
  addStartAndEndSlash: i = !0,
  params: s
}) => {
  let c = !e || typeof e != "string" ? "" : e.startsWith("/") ? e.slice(1) : e;
  if (n && (c = `${((o) => {
    var t;
    let p = o;
    const r = [];
    for (; (t = p == null ? void 0 : p.slug) != null && t.current; )
      r.push(p.slug.current), p = p.slug.prefix;
    return r.reverse().join("/");
  })(n)}/${c}`), i && (c = `/${c}/`), s) {
    const o = Object.entries(s).map(([p, r]) => `${p}=${r}`).join("&");
    c = `${c}?${o}`;
  }
  return c.replace(/\/+/g, "/").toLowerCase();
}, m = (e, n) => {
  const i = n ? n == null ? void 0 : n.replace(/ /g, "") : "";
  return e ? !i || !["#", "?"].includes(i[0]) ? e : `${e}${i}` : "";
}, l = (e) => {
  var n, i;
  if (!e)
    return "";
  if (e.type === "externalLink" && e.externalLink)
    return m(e.externalLink, e.params);
  if (e.type === "anchorId" && e.anchorId)
    return `#${e.anchorId.replace(/[ #]/g, "")}`;
  if (e.type === "internalLink" && e.internalLink) {
    const s = j({
      slug: (n = e.internalLink.slug) == null ? void 0 : n.current,
      prefix: (i = e.internalLink.slug) == null ? void 0 : i.prefix
    });
    return m(s, e.params);
  }
  return "";
};
function q(e, n = 50, i = 300) {
  return e * n || i;
}
function D(e) {
  return e = e.replace(/\/\*[\s\S]*?\*\//g, ""), e = e.replace(/\s*([{}:;,])\s*/g, "$1"), e = e.replace(/;}/g, "}"), e = e.replace(/\s\s+/g, " "), e = e.trim(), e;
}
export {
  V as A,
  q as B,
  l as a,
  j as b,
  m as c,
  v as d,
  O as e,
  $ as f,
  B as g,
  D as h,
  k as i,
  h as j,
  C as k,
  x as l,
  R as m,
  w as n,
  S as o,
  H as p,
  T as q,
  g as r,
  _ as s,
  L as t,
  N as u,
  I as v,
  P as w,
  E as x,
  W as y,
  F as z
};
